// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getClinicPackages } from "../../api";
import { ClinicPackageType } from "../../types";

export const useClinicPackages = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ClinicPackageType>>({
    queryKey: ["clinic-packages", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      return getClinicPackages(token, clinicId);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
